// MealFormModal.jsx
import React, { useState, useEffect, useRef } from "react";
// import {
//   IconButton,
// } from "@mui/material";

// import DeleteIcon from "@mui/icons-material/Delete";
import SpeechTextInput from "../utils/SpeechTextInput";
import { saveImageToIndexedDB } from "../../storage/imageStorage";
import FoodImage from "../utils/FoodImage";

import { IconTrash } from "@tabler/icons-react";

import { colors, space, radius, borders, fontWeight } from "../../design/tokens";

import { 
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Select,
  Row, 
  Grid, 
  Dialog,
  Checkbox
} from "../layout";




import { useDispatch, useSelector } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import { addMeal, updateMeal } from "../../store/mealsSlice";
import { selectAllFoods } from "../../store/selectors";
import FoodOverviewGrid from "../FoodOverviewGrid"; // your existing grid

export default function MealFormModal({ open, meal, onClose, onSave }) {
  const dispatch = useDispatch();
  const foods = useSelector(selectAllFoods);

  const [mealData, setMealData] = useState(getInitial());
  const [foodSelectorOpen, setFoodSelectorOpen] = useState(false);

  const fileInputRef = useRef(null);


  function getInitial() {
    if (meal) return { foodPortions: {}, mealType: "lunch", ...meal };

    return {
      id: nanoid(),
      name: "",
      mealType: "lunch",
      foodPortions: {}, // grams per food
      calories: 0,
      carbs: 0,
      sugar: 0,
      protein: 0,
      fat: 0,
      isRecipe: true,
      imageKey: "",  // ← add this
    };
  }

  useEffect(() => {
    if (open) setMealData(getInitial());
  }, [open, meal]);

  // recalc totals based on grams
  const recalcTotals = (portions) => {
    const totals = foods.reduce(
      (t, f) => {
        const grams = portions[f.id];
        if (grams === undefined) return t;

        const ratio = grams / 100;
        return {
          calories: t.calories + f.calories * ratio,
          carbs: t.carbs + f.carbs * ratio,
          sugar: t.sugar + f.sugar * ratio,
          protein: t.protein + f.protein * ratio,
          fat: t.fat + f.fat * ratio,
        };
      },
      { calories: 0, carbs: 0, sugar: 0, protein: 0, fat: 0 }
    );

    setMealData((prev) => ({ ...prev, ...totals, foodPortions: portions }));
  };

  // toggle food: add default 100g or remove
  const toggleFood = (food) => {
    const portions = { ...mealData.foodPortions };
    if (portions.hasOwnProperty(food.id)) {
      delete portions[food.id]; // remove
    } else {
      portions[food.id] = 100; // add default
    }
    recalcTotals(portions);
  };

  // update grams for a food
  const updateGrams = (id, grams) => {
    const portions = { ...mealData.foodPortions, [id]: grams };
    recalcTotals(portions);
  };

  const handleSave = () => {
    console.log("saving meal with imageKey:", mealData.imageKey); // ← check this
    meal?.id
      ? dispatch(updateMeal(mealData))
      : dispatch(addMeal(mealData));

    onSave?.(mealData); // 🔥 notify parent if provided
    onClose();
  };



  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const imageKey = `meal_${mealData.id}`;
     console.log("saving image with key:", imageKey); // ← add this
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.src = url;
    img.onload = () => {
      URL.revokeObjectURL(url);
      const canvas = document.createElement("canvas");
      canvas.width = 100; canvas.height = 100;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 100, 100);
      canvas.toBlob(async (blob) => {
        await saveImageToIndexedDB(imageKey, blob);
        setMealData((prev) => ({ ...prev, imageKey }));
      }, "image/jpeg", 0.7);
    };
  };

  return (
      <Dialog open={open} onClose={onClose} label="Create new meal">
        <Card
          style={{
            padding:"0px 16px",
          }}
        >
          {mealData.imageKey ? (
              <FoodImage imageKey={mealData.imageKey} alt={mealData.name} />
            ) : (
              <Card style={{ width: "100%", height: 140, display: "flex", alignItems: "center", justifyContent: "center" }}>
                No Image
              </Card>
            )}

            <Button onClick={() => fileInputRef.current.click()} style={{ marginBottom: space.md }}>
              Upload / Take Photo
            </Button>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              ref={fileInputRef}
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
        {/* <TextInput
          label="Meal Name"
          value={mealData.name}
          onChange={(e) =>
            setMealData((prev) => ({ ...prev, name: e.target.value }))
          }
          style={{ marginBottom: space.md }}
        /> */}
        <SpeechTextInput
          label="Meal Name"
          value={mealData.name}
          onChange={(e) =>
            setMealData((prev) => ({ ...prev, name: e.target.value }))
          }
          onSpeechResult={(text) =>
            setMealData((prev) => ({ ...prev, name: text }))
          }
          style={{ marginBottom: space.md }}
        />

        <Select
          value={mealData.mealType}
          placeholder="Meal type"
          options={[
            { label: "Breakfast", value: "breakfast" },
            { label: "Lunch", value: "lunch" },
            { label: "Dinner", value: "dinner" },
            { label: "Snack", value: "snack" },
          ]}
          onChange={(mealType) =>
            setMealData(prev => ({
              ...prev,
              mealType
            }))
          }
          style={{ marginBottom: space.md }}
        />


        {/* Add Food button */}
        <Button
          style={{ marginBottom: space.md }}
          onClick={() => setFoodSelectorOpen(true)}
        >
          Add Food
        </Button>

        {/* Food Cards */}
        {Object.keys(mealData.foodPortions).map((foodId) => {
          const food = foods.find((f) => f.id === foodId);
          if (!food) return null;

          const grams = mealData.foodPortions[foodId];
          const calories = (food.calories * grams) / 100;

          return (
     
             <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <Text style={{ marginBottom: space.md }}>{food.name} {calories.toFixed(0)} kcal</Text>

                
                <div 
                  style={{
                    display: "flex",
                    alignItems: "center"
                    
                  }}
                >
                <TextInput
                  value={grams}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) =>
                    updateGrams(food.id, Number(e.target.value))
                  }
                  slim
                
                  style={{
                    padding: "1px 0",
                    borderRadius: "0px",
                    width: "50px",
                    fontSize: "12px",
                    lineHeight: "1",
                    textAlign: "right",
                  }}
                />
                <Text
                  style={{
                    width: "auto",
                    fontSize: "12px",
                    lineHeight: "1",
                    // textAlign: "right",
                    paddingBottom: "10px",
                    marginLeft: "5px",
                  }}
                >
                  grams</Text>
                </div>





                {/* <IconButton
                  size="small"
                  color="error"
                  sx={{ position: "absolute", top: 8, right: 8 }}
                  onClick={() => {
                    const portions = { ...mealData.foodPortions };
                    delete portions[food.id];
                    recalcTotals(portions);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton> */}

                <Button
                  onClick={() => {
                    const portions = { ...mealData.foodPortions };
                    delete portions[food.id];
                    recalcTotals(portions);
                  }}
                  slim
                  style={{
                    display: "block",
                    margin: "0 auto 5px",
                    width: "auto",
                    padding: "5px",
                    fontSize: "12px",
                    borderRadius:"0px"
                  }}
                >
                  <IconTrash
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                  />
                </Button>
            </Row>
          );
        })}

        {/* <Text  style={{ fontWeight: fontWeight.bold, marginBottom: space.md }}>
          Total: {mealData.calories.toFixed(0)} kcal
        </Text>

        <Button onClick={handleSave} style={{ marginBottom: space.md }}>
          Save Meal
        </Button> */}

        {/* 🔥 Food Selector Grid Modal */}
        {foodSelectorOpen && (
          <Card>

            <Text  style={{ fontWeight: fontWeight.bold, marginBottom: space.md }}>
              Select Foods
            </Text>

            <FoodOverviewGrid
              foods={foods.filter(f => !mealData.foodPortions[f.id])} // optional filter
              onSelectFood={(food) => {
                const portions = { ...mealData.foodPortions, [food.id]: 100 };
                recalcTotals(portions);
              }}
            />

            <Button
              onClick={() => setFoodSelectorOpen(false)}
              style={{ marginBottom: space.md }}
            >
              Close food Selector
            </Button>
          </Card>
        )}
                <Text  style={{ fontWeight: fontWeight.bold, marginBottom: space.md }}>
          Total: {mealData.calories.toFixed(0)} kcal
        </Text>

        <Button onClick={handleSave} style={{ marginBottom: space.md }}>
          Save Meal
        </Button>
      </Card>
    </Dialog>
  );
}